var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("activator",function(){return [_c('v-btn',_vm._g({on:{"click":_vm.logout}},_vm.slotEvents),[_vm._v("Logout")])]},null,{ on: _vm.slotEvents })],2)}
var staticRenderFns = []

export { render, staticRenderFns }